import { ShieldCheck, Clock, FileText, Calculator, Calendar, Award } from 'lucide-react';

const PLANNED_FEATURES = [
  { icon: Calculator, title: 'PF / ESIC Filing', desc: 'Automated ECR (Electronic Challan-cum-Return) generation for EPFO. Employee-wise PF and ESIC calculations every month.' },
  { icon: FileText, title: 'Professional Tax', desc: 'State-wise PT slab computation. Automated deduction from payroll and monthly challan generation.' },
  { icon: FileText, title: 'TDS & Form 24Q', desc: 'Quarterly TDS returns (Form 24Q), employee-wise TDS computation based on salary structure and investment declarations.' },
  { icon: Award, title: 'Form 16 Generation', desc: 'Annual TDS certificate (Form 16) generation for all employees. PDF download with digital signature placeholder.' },
  { icon: Calendar, title: 'Compliance Calendar', desc: 'Due date reminders for all statutory filings — PF, ESIC, PT, TDS — with penalty calculation for late filing.' },
];

export default function CompliancePage() {
  return (
    <div className="flex flex-col items-center justify-start py-12 px-4 fade-in">
      <div className="w-full max-w-[600px] space-y-8">
        {/* Header */}
        <div className="text-center">
          <div className="w-16 h-16 rounded-[20px] bg-emerald-500/10 flex items-center justify-center mx-auto mb-4">
            <ShieldCheck size={28} className="text-emerald-600" />
          </div>
          <h1 className="text-[24px] font-bold text-[var(--text-primary)]">Statutory Compliance</h1>
          <div className="flex items-center justify-center gap-2 mt-2">
            <Clock size={14} className="text-amber-500" />
            <span className="text-[13px] font-semibold text-amber-600 dark:text-amber-400">Coming Soon</span>
          </div>
          <p className="text-[13px] text-[var(--text-secondary)] mt-3 max-w-[420px] mx-auto">
            Automated statutory compliance management for Indian organizations — PF, ESIC, Professional Tax, and TDS. Here's what's coming:
          </p>
        </div>

        {/* Feature list */}
        <div className="space-y-3">
          {PLANNED_FEATURES.map(f => (
            <div key={f.title} className="card p-4 flex items-start gap-4">
              <div className="w-9 h-9 rounded-[10px] bg-emerald-500/10 flex items-center justify-center shrink-0">
                <f.icon size={16} className="text-emerald-600" />
              </div>
              <div>
                <p className="text-[13px] font-semibold text-[var(--text-primary)]">{f.title}</p>
                <p className="text-[12px] text-[var(--text-secondary)] mt-0.5">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer note */}
        <div className="rounded-[12px] border border-[var(--border)] bg-[var(--bg-muted)] px-4 py-3 text-center">
          <p className="text-[12px] text-[var(--text-secondary)]">
            Until then, manage compliance filings manually through the
            <span className="font-semibold"> EPFO, ESIC, and Income Tax portals</span>.
            PF and ESIC deductions are already computed in the{' '}
            <span className="font-semibold text-[var(--accent)]">Payroll module</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
